import React, { useEffect, useState } from 'react'
import SimpleBarFilterCustom from '../../../components/Common/SimpleBarFilterCustom'
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row
} from 'reactstrap'
import ProgressBar from '../../../components/Common/ProgressBar'
import InputSearch from '../../../components/Inputs/InputSearch'

import HeaderDefaultToPage from '../../../components/Common/headerDefaultToPage'
import PreFilterBadge from '../../../components/Common/PreFilterBadge'
import { exportGridToExcel, exportGridToCSV, exportGridToHTML, exportDashboardToHTML } from '../../../components/Utils/export'
import TranspaleStringToComponente from '../../../components/Dynamic/TranspaleStringToComponente'
import { useSelector } from 'react-redux'

const EXPORT_COLUMNS = [
  { field: "Status", header: "Status", width: '5%', hasImage: true, Export: true },
  { field: "ID_Arquivo", header: "ID", Export: true },
  { field: "Processamento", header: "Processou em", Export: true },
  { field: "Nota_Fiscal", header: "Nº NF-e", Export: true },
  { field: "Documentos_Relacionados", header: "Nº Ped", Export: true },
  { field: "Fornecedor", header: "Emissor", hasImage: true, Export: true },
  { field: "Revenda", header: "Destinatário", hasImage: true, Export: true },
  { field: "Local_Entrega", header: "Local de Entrega", hasImage: true, Export: true },
  { field: "Valor", header: "Valor NF-e", Export: true },
  { field: "Coluna_Data_Agendamento", header: "Data Agendamento", Export: true },
  { field: "Coluna_Funcoes", header: "Funções", width: '5%', hasImage: true, Export: false },
]

export default function GridHeader({ context }) {
  const {
    isLoading,
    paramsOnFilter,
    setParamsOnFilter,
    setTriggerOnFilter,
    setIsOpenModal,
    isOpenModal,
    setInputGlobalSearchValue,
    filteredData,
    userProfile
  } = React.useContext(context)
  
  const [preFilter, setPreFilter] = useState([])
  const [btnActionExport, setBtnActionExport] = useState(false)
  const [isExporting, setIsExporting] = useState(false)
  const [exportProgress, setExportProgress] = useState(0)
  const [showProgressBar, setShowProgressBar] = useState(false)
  const [progressMessage, setProgressMessage] = useState('')
  const [advancedFilters, setAdvancedFilters] = useState(false)
  const isIframePage = useSelector(state => state.Layout.isIframePage)
  const pageTitle = 'Validar Nota Fiscal'

  const handleExport = async (item) => {
    try {
      setIsExporting(true)
      setShowProgressBar(true)
      setExportProgress(0)

      const icone = item?.icone || ''
      const label = (item?.label || '').toLowerCase()
      const transactionCode = "EDI_PedidosdeCompra"

      const options = {
        title: pageTitle,
        transactionCode,
        appliedFilters: paramsOnFilter,
        filteredData,
        columns: EXPORT_COLUMNS
      }
    
      setExportProgress(5)
      await new Promise(resolve => setTimeout(resolve, 100))

      if (icone.includes('fa-file-pdf') || label.includes('pdf')) {
        // PDF: usar a mesma lógica que HTML (gerar HTML e enviar para API /gerar-pdf)
        setExportProgress(30)
        setProgressMessage('Gerando PDF...')
        await new Promise(resolve => setTimeout(resolve, 200))
        
        if (!hasGridTable) {
          // Para dashboard, gerar PDF via DOCVIEW usando a API /gerar-pdf
          // A função exportDashboardToHTML internamente chama /gerar-pdf e retorna PDF
          console.log('[GridHeader] Iniciando geração de PDF do dashboard...')
          try {
            await exportDashboardToHTML([], { ...options, filename: 'dashboard.pdf' })
            console.log('[GridHeader] PDF gerado com sucesso!')
          } catch (error) {
            console.error('[GridHeader] Erro ao gerar PDF:', error)
            setProgressMessage('Erro ao gerar PDF. Verifique o console.')
            throw error
          }
        } else {
          // Para grid, gerar HTML e enviar para API /gerar-pdf
          console.log('[GridHeader] Iniciando geração de PDF do grid...')
          try {
            await exportGridToHTML({ ...options, filename: 'relatorio.pdf' })
            console.log('[GridHeader] PDF gerado com sucesso!')
          } catch (error) {
            console.error('[GridHeader] Erro ao gerar PDF:', error)
            setProgressMessage('Erro ao gerar PDF. Verifique o console.')
            throw error
          }
        }
        setExportProgress(90)
        setProgressMessage('Concluído!')
        await new Promise(resolve => setTimeout(resolve, 200))
        
      } else if (icone.includes('fa-file-excel') || label.includes('excel') || label.includes('xlsx')) {
        setExportProgress(30)
        await new Promise(resolve => setTimeout(resolve, 200))
        exportGridToExcel({ ...options, filename: 'relatorio.xlsx' })
        setExportProgress(90)
        await new Promise(resolve => setTimeout(resolve, 200))
        
      } else if (icone.includes('fa-file-csv') || label.includes('csv')) {
        setExportProgress(30)
        await new Promise(resolve => setTimeout(resolve, 200))
        exportGridToCSV({ ...options, filename: 'relatorio.csv' })
        setExportProgress(90)
        await new Promise(resolve => setTimeout(resolve, 200))
        
      } else if (icone.includes('fa-file-code') || label.includes('html')) {
        // HTML: sempre retornar HTML (não converter para PDF)
        setExportProgress(30)
        setProgressMessage('Gerando HTML...')
        await new Promise(resolve => setTimeout(resolve, 200))
        
        if (!hasGridTable) {
          // Para dashboard, retornar HTML (não converter para PDF)
          console.log('[GridHeader] Iniciando geração de HTML do dashboard...')
          try {
            await exportDashboardToHTML([], { ...options, filename: 'dashboard.html', convertToPdf: false })
            console.log('[GridHeader] HTML gerado com sucesso!')
          } catch (error) {
            console.error('[GridHeader] Erro ao gerar HTML:', error)
            setProgressMessage('Erro ao gerar HTML. Verifique o console.')
            throw error
          }
        } else {
          // Para grid, retornar HTML (não converter para PDF)
          console.log('[GridHeader] Iniciando geração de HTML do grid...')
          try {
            await exportGridToHTML({ ...options, filename: 'relatorio.html', convertToPdf: false })
            console.log('[GridHeader] HTML gerado com sucesso!')
          } catch (error) {
            console.error('[GridHeader] Erro ao gerar HTML:', error)
            setProgressMessage('Erro ao gerar HTML. Verifique o console.')
            throw error
          }
        }
        setExportProgress(90)
        setProgressMessage('Concluído!')
        await new Promise(resolve => setTimeout(resolve, 200))
      }

      // Finalização
      setExportProgress(100)
      
    } catch (error) {
      console.error('Erro na exportação:', error)
      // Se houver erro na geração de PDF, mostrar mensagem amigável
      if (error.message && error.message.includes('PDF')) {
        setProgressMessage('Erro ao gerar PDF. Verifique o console para mais detalhes.')
      }
    } finally {
      setIsExporting(false)
      setBtnActionExport(false)
      setShowProgressBar(false)
      setExportProgress(0)
      setProgressMessage('')
    }
  }

  const hasGridTable = true

  const onSubmitFilter = data => {
    setIsOpenModal(false)
    setParamsOnFilter([{ ...data[0] }])
    setTriggerOnFilter(true)
  }

  const onClearFilter = () => {
    setParamsOnFilter([{Filtro_Data_Inicio: {value: new Date().toLocaleDateString(), field: "De"}, Filtro_Data_Termino: {value: new Date().toLocaleDateString(), field: "Até"}}])
    setPreFilter([{Filtro_Data_Inicio: {value: new Date().toLocaleDateString(), field: "De"}, Filtro_Data_Termino: {value: new Date().toLocaleDateString(), field: "Até"}}])
    setIsOpenModal(false)
    setTriggerOnFilter(true)
  }

  useEffect(() => {
    setTriggerOnFilter(true)
  }, [])

  return (
    <>
      <Row>
        <Col
          lg={12}
          className={`mb-3 nav-accordion-custom ${isLoading ? 'disabled' : ''}`}
        >
          <Row className={`d-flex align-items-center justify-content-between pb-3`}>
            <Col id="header-primary-title" > 
            
              <HeaderDefaultToPage
              goBack={isIframePage ? false : true}
              title={pageTitle}
            />
            </Col>
            <Col
            id="header-secundary-actions"
              lg={6}
              className="d-flex justify-content-end gap-3 align-items-center"
            >
              <Button
                onClick={() => onSubmitFilter(preFilter)}
                className="bg-transparent border-0 p-0 m-0"
              > 
              <i className="fa-solid font-size-24 fa-rotate-right text-primary-dark"></i>                  
              </Button>
              <Button
                onClick={() => window.print()}
                className="bg-transparent border-0 p-0 m-0"
              > 
              <i className="fas font-size-24 fa-print text-primary-dark"></i>                  
              </Button>
              <Dropdown
                isOpen={btnActionExport}
                toggle={() => setBtnActionExport(!btnActionExport)}
                className="dropdown-export-dynamic w-auto"
              >
                <DropdownToggle
                  className="bg-transparent border-0 p-0 m-0"
                  caret
                  disabled={isExporting}
                >
                  {isExporting ? (
                    <div className="spinner-border spinner-border-sm text-primary" role="status" />
                  ) : (                                                
                    <i className="fas font-size-24 fa-save text-primary-dark"></i>                        
                  )}
              </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem
                      onClick={() => handleExport({icone: 'fa-solid fa-file-pdf', label: 'pdf'})}
                      className="d-flex align-items-center gap-3"
                    >
                      <i className={'fa-solid fa-file-pdf'}></i>
                      <span>PDF</span>
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => handleExport({icone: 'fa-solid fa-file-xls', label: 'excel'})}
                      className="d-flex align-items-center gap-3"
                    >
                      <i className={'fa-solid fa-file-xls'}></i>
                      <span>XLS</span>
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => handleExport({icone: 'fa-solid fa-file-csv', label: 'csv'})}
                      className="d-flex align-items-center gap-3"
                    >
                      <i className={'fa-solid fa-file-csv'}></i>
                      <span>CSV</span>
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => handleExport({icone: 'fa-solid fa-file-code', label: 'html'})}
                      className="d-flex align-items-center gap-3"
                    >
                      <i className={'fa-solid fa-file-code'}></i>
                      <span>HTML</span>
                    </DropdownItem>
              </DropdownMenu>
              </Dropdown>
              
              <form onSubmit={() => {}}>
                <InputSearch
                  placeholder={'Busca rápida'}
                  onChange={e => setInputGlobalSearchValue(e)}
                />
              </form>

              <SimpleBarFilterCustom
                isOpen={isOpenModal}
                onClose={setIsOpenModal}
                onSubmit={() => onSubmitFilter(preFilter)}
                onClearFilter={onClearFilter}
              >
                <Row className="m-0 mb-1 form-custom01-filter">
                  <div className="m-0 p-0">
                    <TranspaleStringToComponente
                      elementId={"Data_Inicio"}
                      elementProps={{
                        value: new Date().toLocaleDateString(),
                        type: 'Date',
                        title: "De",
                        id: "Filtro_Data_Inicio"
                      }}
                      preFilter={preFilter}
                      onDefaultValue={(value) => setParamsOnFilter(state => [{ ...state[0], ...value }])}
                      onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                    />
                    <TranspaleStringToComponente
                      elementId={"Data_Termino"}
                      elementProps={{
                        value: new Date().toLocaleDateString(),
                        type: 'Date',
                        title: "Até",
                        id: "Filtro_Data_Termino",
                      }}
                      preFilter={preFilter}
                      onDefaultValue={(value) => setParamsOnFilter(state => [{ ...state[0], ...value }])}
                      onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                    />
                    <TranspaleStringToComponente
                      elementId={"ID_Empresa_Origem"}
                      elementProps={{
                        value: '',
                        type: 'Combobox',
                        title: "Empresa origem",
                        id: "Filtro_ID_Empresa_Origem",
                        isDisabled: false,
                        procedure: "FRONT_Componente_Combo_Empresas",
                        procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'ORIGEM', 'NF']
                      }}
                      preFilter={preFilter} 
                      onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                    />
                    <TranspaleStringToComponente
                      elementId={"ID_Planta_Origem"}
                      elementProps={{
                        value: '',
                        type: 'Combobox',
                        title: "Planta origem",
                        id: "Filtro_ID_Planta_Origem",
                        isDisabled: false,
                        procedure: "FRONT_Componente_Combo_Plantas",
                        procedureParams: [`${userProfile?.ID_Usuario}`, 'pt-BR','<#Filtro_ID_Empresa_Origem#>', 'ORIGEM', 'NF'],
                        alienated: ["Filtro_ID_Empresa_Origem"]
                      }}
                      preFilter={preFilter} 
                      onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                    />
                    <TranspaleStringToComponente
                      elementId={"ID_Empresa_Destino"}
                      elementProps={{
                        value: '',
                        type: 'Combobox',
                        title: "Empresa destino",
                        id: "Filtro_ID_Empresa_Destino",
                        isDisabled: false,
                        procedure: "FRONT_Componente_Combo_Empresas",
                        procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'DESTINO', 'NF']
                      }}
                      preFilter={preFilter} 
                      onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                    />
                    <TranspaleStringToComponente
                      elementId={"ID_Planta_Destino"}
                      elementProps={{
                        value: '',
                        type: 'Combobox',
                        title: "Planta destino",
                        id: "Filtro_ID_Planta_Destino",
                        isDisabled: false,
                        procedure: "FRONT_Componente_Combo_Plantas",
                        procedureParams: [`${userProfile?.ID_Usuario}`, 'pt-BR','<#Filtro_ID_Empresa_Destino#>', 'ORIGEM', 'NF'],
                        alienated: ["Filtro_ID_Empresa_Destino"]
                      }}
                      preFilter={preFilter} 
                      onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                    />
                    <TranspaleStringToComponente
                      elementId={"Numero_Documento_Nota"}
                      elementProps={{
                        value: '',
                        type: 'Input',
                        title: "Número Nota Fiscal",
                        id: "Filtro_Numero_Documento_Nota",
                        isDisabled: false
                      }}
                      preFilter={preFilter} 
                      onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                    />
                    <hr />
                    <div className='d-flex justify-content-between cursor-pointer mb-3' onClick={() => setAdvancedFilters(!advancedFilters)}>
                      <small>Filtro avançado</small>
                      <i className={`fa-solid fa-${!advancedFilters ? 'plus' : 'minus'}`}></i>
                    </div>
                    {advancedFilters && (
                      <div className='px-2'>
                        <TranspaleStringToComponente
                          elementId={"Status_Documento"}
                          elementProps={{
                            value: "",
                            type: 'Combobox',
                            title: "Status Documento",
                            placeholder: "Selecionar",
                            id: "Filtro_Status_Documento",
                            isDisabled: false,
                            dataOptions: [
                              {'value': 'A', 'label': 'Ativo'}, 
                              {'value': 'D', 'label': 'Anulado'},
                              {'value': 'C', 'label': 'Cancelado'}, 
                              {'value': 'O', 'label': 'Obsoleto'}
                            ],
                            isMultiSelection: true
                          }}
                          preFilter={preFilter} 
                          onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                        />
                        <TranspaleStringToComponente
                          elementId={"Status_Validacao"}
                          elementProps={{
                            value: "",
                            type: 'Combobox',
                            title: "Status Validação",
                            id: "Filtro_Status_Validacao",
                            isDisabled: false,
                            dataOptions: [
                              {'value': 'N', 'label': 'Não validado'}, 
                              {'value': 'V', 'label': 'Validado'}, 
                              {'value': 'R', 'label': 'Rejeitado'},
                              {'value': 'Y', 'label': 'Entregue'}
                            ],
                            isMultiSelection: true
                          }}
                          preFilter={preFilter} 
                          onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                        />                    
                        <TranspaleStringToComponente
                          elementId={"Status_Integracao"}
                          elementProps={{
                            value: "",
                            type: 'Combobox',
                            title: "Status Integração",
                            id: "Filtro_Status_Integracao",
                            isDisabled: false,
                            dataOptions: [
                              {'value': 'S', 'label': 'Sucesso'}, 
                              {'value': 'A', 'label': 'Alerta'}, 
                              {'value': 'P', 'label': 'Processando'},
                              {'value': 'E', 'label': 'Erro'},
                              {'value': 'N', 'label': 'Não Iniciada'},
                              {'value': 'I', 'label': 'Integrado Anteriormente'},
                              {'value': 'T', 'label': 'Erro ao Integrar Anteriormente'},
                            ],
                            isMultiSelection: true
                          }}
                          preFilter={preFilter} 
                          onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                        />                    
                        {/* <TranspaleStringToComponente
                          elementId={"Status_Aceite"}
                          elementProps={{
                            value: "",
                            type: 'Combobox',
                            title: "Status Aceito ou Recusado",
                            id: "Filtro_Status_Aceite",
                            isDisabled: false,
                            dataOptions: [
                              {'value': 'A', 'label': 'Aceito'}, 
                              {'value': 'R', 'label': 'Recusado'}, 
                              {'value': 'D', 'label': 'Pendente'},
                              {'value': 'N', 'label': 'Obsoleto'},
                              {'value': 'P', 'label': 'Processando'}
                            ],
                            isMultiSelection: true
                          }}
                          preFilter={preFilter} 
                          onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                        /> */}
                        <TranspaleStringToComponente
                          elementId={"Status_Leitura"}
                          elementProps={{
                            value: "",
                            type: 'Combobox',
                            title: "Status Leitura",
                            id: "Filtro_Status_Leitura",
                            isDisabled: false,
                            dataOptions: [
                              {'value': 'S', 'label': 'Lido'}, 
                              {'value': 'N', 'label': 'Não Lido'}
                            ],
                            isMultiSelection: true
                          }}
                          preFilter={preFilter} 
                          onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                        />
                        {/* <TranspaleStringToComponente
                          elementId={"Status_Cotacao"}
                          elementProps={{
                            value: "",
                            type: 'Combobox',
                            title: "Status Cotação",
                            id: "Filtro_Status_Cotacao",
                            isDisabled: false,
                            dataOptions: [
                              {'value': 'N', 'label': 'Pedidos'}, 
                              {'value': 'S', 'label': 'Cotação'}
                            ],
                            isMultiSelection: true
                          }}
                          preFilter={preFilter} 
                          onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                        />                     */}
                        {/* <TranspaleStringToComponente
                          elementId={"Status_Saldo"}
                          elementProps={{
                            value: "",
                            type: 'Combobox',
                            title: "Status Saldo",
                            id: "Filtro_Status_Saldo",
                            isDisabled: false,
                            dataOptions: [
                              {'value': 'N', 'label': 'Não faturado'}, 
                              {'value': 'P', 'label': 'Parcialmente'},
                              {'value': 'F', 'label': 'Faturado'}
                            ],
                            isMultiSelection: true
                          }}
                          preFilter={preFilter} 
                          onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                        /> */}
                        <TranspaleStringToComponente
                          elementId={"ID_Categorias"}
                          elementProps={{
                            value: '',
                            type: 'Combobox',
                            title: "Categorias",
                            placeholder: "Selecione a empresa origem",
                            id: "Filtro_ID_Categorias",
                            isDisabled: false,
                            procedure: "FRONT_Obter_Categorias",
                            procedureParams: ['<#Filtro_ID_Empresa_Origem#>'],
                            alienated: ["Filtro_ID_Empresa_Origem"]
                          }}
                          preFilter={preFilter} 
                          onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                        />
                        <TranspaleStringToComponente
                          elementId={"Documento_Relacionado_Nota"}
                          elementProps={{
                            value: '',
                            type: 'Input',
                            title: "Número Pedido",
                            id: "Filtro_Documento_Relacionado_Nota",
                            isDisabled: false
                          }}
                          preFilter={preFilter} 
                          onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])} 
                        />
                      </div>
                    )}
                  </div>
                </Row>
              </SimpleBarFilterCustom>
              <Button
                onClick={() => setIsOpenModal(true)}
                style={{ height: 40, width: 113 }}
                className="button-filter-action font-w-600 bg-primary-dark border-0 text-white px-4 btn-hover-primary"
              >
                Filtros
              </Button>
            </Col>
            <Col md={12}>
              {paramsOnFilter[0] &&
                Object.keys(paramsOnFilter[0]).length !== 0 && (
                <div className="container-pre-filter-header">
                  <div className="d-flex flex-wrap p-0 gap-2 align-items-center">
                    <button className="btn px-0 border-0 text-black fonto-w-500 font-size-12">
                      Filtros aplicados:
                    </button>
                    {Object.keys(paramsOnFilter[0]).map((key, i) => {
                        if (Array.isArray(paramsOnFilter[0][key])) {
                        return (
                          <>
                              {paramsOnFilter[0][key][0].values.map(
                                (item, _i) => (
                              <PreFilterBadge
                                key={_i}
                                index={_i}
                                field={paramsOnFilter[0][key][0].field}
                                value={item.label || item.value}
                                callback={index => {
                                  const obj = { ...paramsOnFilter[0] }
                                  const pre = { ...preFilter[0] }

                                  let values = pre[key][0]?.values || []
                                      values = values.filter(
                                        (_, i) => i !== index
                                      )

                                      obj[key] = [
                                        { ...obj[key][0], values: values }
                                      ]
                                      pre[key] = [
                                        { ...pre[key][0], values: values }
                                      ]
                                  
                                  if (values.length === 0) {
                                    delete obj[key]
                                    delete pre[key]
                                  }
                                  
                                  setPreFilter([pre])
                                  onSubmitFilter([obj])
                                }}
                              />
                                )
                              )}
                          </>
                        )                          
                        } else {
                          return (
                            <PreFilterBadge
                              key={i}
                              index={i}
                              field={paramsOnFilter[0][key].field}
                              label={paramsOnFilter[0][key]?.isSelect ? '' : key}
                              value={
                                paramsOnFilter[0][key].label ||
                                paramsOnFilter[0][key].value
                              }
                              callback={() => { 
                                const obj = { ...paramsOnFilter[0] }
                                const pre = { ...preFilter[0] }
                                delete obj[key]
                                delete pre[key]
                                setPreFilter([pre])
                                onSubmitFilter([obj])
                              }} 
                            />
                          )
                      }
                    })}                    
                  </div>
                </div>
              )}
            </Col>
          </Row>
          
          {/* Progress Bar para Exportação */}
          <ProgressBar
            progress={exportProgress}
            message={progressMessage || 'Gerando relatório...'}
            isVisible={showProgressBar}
            showPercentage={true}
            autoHide={true}
            className="export-progress-bar"
          />
          
        </Col>
      </Row>
    </>
  )
}